
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const DocWord = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="DocWord" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M9 0H2v16h12V5zm3.6 5H9V1.4zm.4 10H3V1h5v5h5zm-2.7-2H8.7l-.479-2.178c-.023-.091-.059-.273-.108-.544s-.085-.5-.108-.68q-.027.222-.088.552t-.122.607q-.06.277-.5 2.243h-1.6L4.456 8h1.3l.543 2.507q.186.831.255 1.324c.029-.233.082-.548.158-.947s.147-.73.214-.992L7.366 8h1.253l.427 1.892c.073.3.148.653.222 1.05s.126.693.15.889q.047-.38.244-1.317L10.216 8h1.3z" />
</svg>
    </HvIconBase>
)};

DocWord.propTypes = HvIconBase.propTypes;

export default DocWord;